<template>
	<section class="newsletter-section">
		<div class="row">
			<div class="columns column5">
				<h2>{{ header }}</h2>
				<div v-parse-links v-html="content" />
			</div>
			<div class="columns column7">
				<!-- Begin Mailchimp Signup Form -->
				<div id="mc_embed_signup">
					<form
						id="mc-embedded-subscribe-form"
						action="https://hotelwesseling.us3.list-manage.com/subscribe/post?u=93a5e4fad5d68ba1b97003cc7&amp;id=518d879676&amp;v_id=35&amp;f_id=00c0c2e1f0"
						method="post"
						name="mc-embedded-subscribe-form"
						class="validate newsletter"
						target="_blank"
						novalidate
					>
						<div id="mc_embed_signup_scroll">
							<div class="mc-field-group newsletter-form">
								<input
									id="mce-EMAIL"
									type="email"
									value=""
									name="EMAIL"
									class="required email"
									:placeholder="$t('formEmail')"
								/>
								<input
									id="mc-embedded-subscribe"
									type="submit"
									name="subscribe"
									class="button"
									:value="button"
								/>
							</div>
							<div>
								<div id="mce-responses" class="clear">
									<div id="mce-error-response" class="response" style="display: none" />
									<div id="mce-success-response" class="response" style="display: none" />
								</div>
								<!-- real people should not fill this in - do not remove this or risk bot signups-->
								<div style="position: absolute; left: -5000px" aria-hidden="true">
									<input
										type="text"
										name="b_b521529c4c6438a654a58038b_17a68eafe6"
										tabindex="-1"
										value=""
									/>
								</div>
							</div>
						</div>
					</form>
				</div>
				<!-- end Mailchimp Signup Form -->
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.newsletter-section {
	padding: 75px 0;
	background: var(--primary-background-color);
	color: var(--body-color);

	form {
		margin-top: 30px;
		padding: 70px;
		background-color: var(--cta-color);

		input {
			background: rgb(225 225 225 / 30%);
			border: 1px solid #fff;
			padding: 15px;
			height: 52px;
			width: 60%;
			vertical-align: top;
			border-radius: 0;

			&::placeholder {
				color: #fff;
				font-family: var(--body-font-family);
				font-size: var(--body-font-size);
				text-transform: uppercase;
			}

			&.button {
				line-height: 22px;
				background: var(--cta-color);
				color: #fff;
				border: 1px solid #fff;
				font-size: var(--body-font-size);
				width: 40%;
				border-radius: 0;

				&:hover {
					background: var(--cta-color-hover);
					color: #fff;
				}
			}
		}
	}
}

@media (max-width: 1480px) {
	newsletter-section {
		form {
			input {
				&::placeholder {
					font-size: 12px !important;
				}

				&.button {
					font-size: 12px !important;
				}
			}
		}
	}
}

@media (max-width: 550px) {
	.newsletter-section {
		padding: 75px 0;

		form {
			margin-top: 30px;
			padding: 50px 20px;

			input {
				background: rgb(225 225 225 / 30%);
				border: 1px solid #fff;
				padding: 15px;
				height: 52px;
				width: 100%;
				border-radius: 0;
				display: block;

				&::placeholder {
					color: #fff;
					font-family: var(--body-font-family);
					font-size: 12px;
					text-transform: uppercase;
					text-align: center;
				}

				&.button {
					line-height: 22px;
					background: var(--cta-color);
					color: #fff;
					border: 1px solid #fff;
					font-size: 12px;
					width: 100%;
					border-radius: 0;
					margin: 20px 0 0 auto;

					&:hover {
						background: var(--cta-color-hover);
						color: #fff;
					}
				}
			}
		}
	}
}
</style>
